import { useMemo } from "react";

import type { ExistingRoomEditDefault_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useInitProductRoomFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-mode/server-model-to-input-mode";
import { useRoomEditMutation } from "../../../repository/existing";

import type { ProductExistingRoomFormModelContextType } from "../../../../ui/existing/context/context";

type Props = {
	serverModel: ExistingRoomEditDefault_EditPageQuery;
};

export const useInitialized = ({ serverModel }: Props): ProductExistingRoomFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = useMemo(() => {
		return {
			hotelPolicy: {
				amenities: serverModel.hotelPolicy?.amenities ?? [],
				requiredPrepMillisecond: serverModel.hotelPolicy?.requiredPrepMillisecond ?? 0,
			},
			connection: {
				planNameAndIDOptions: [
					...serverModel.planList.plans.map(
						(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
					),
					...serverModel.planList.secrets.map(
						(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
					),
				],
			},
			discountList: serverModel.discountList,
		} satisfies ProductExistingRoomFormModelContextType["queryData"];
	}, [serverModel]);

	const { onSetViewModel, viewModel, onResetViewModel } = useInitProductRoomFormModelContext({
		inputModel,
		queryData,
	});

	const { onUpdateRoom: onUpdate } = useRoomEditMutation({ resetForm: onResetViewModel });

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
	};
};
